import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { HeaderIllegal } from "../../HeaderIllegal";
import IllegalConstructionSidebar from "../../IllegalConstructionSidebar/IllegalConstructionSidebar";
import { ZoneNameCommanDDL } from "../../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { WardNameCommanDDL } from "../../../../../../../Components/IllegalDDL/WardNameCommanDDL";
import UploadComplaintDetailsPopup from "../../ClosedComplaintIllegalGrid/Modal/UploadComplaintDetailsPopup";
import SiteVisitDetailsPopup from "../../ClosedComplaintIllegalGrid/Modal/SiteVisitDetailsPopup";
import BoundariesPopup from "../../ClosedComplaintIllegalGrid/Modal/BoundariesPopup";
import { ConstructionTypeCommanDDL } from "../../../../../../../Components/IllegalDDL/ConstructionTypeCommanDDL";
import ActionPopup from "../../SiteVisit/SiteVisitIllegalGrid/Modal/ActionPopup";
import TrackPopup from "../../SiteVisit/SiteVisitIllegalGrid/Modal/TrackPopup";

export const SiteVerificationIllegalGrid = () => {

    const { t } = useTranslation()
    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };


    const [DashType, setDashType] = useState(localStorage.getItem('DashType') ? localStorage.getItem('DashType') : 1)

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])


    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const DataObj = ({
        isCountLoading: '',
        Language: Language.Label
    })

    const [DesignationNameID, setDesignationNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ForwardPopUpShow, setForwardPopUpShow] = useState(false)

    const handleForward = () => {
        setForwardPopUpShow(!ForwardPopUpShow)
    }

    const [BoundariesPopUpShow, setBoundariesPopUpShow] = useState(false)
    const [ActionPopUpShow, setActionPopUpShow] = useState(false)
    const [TitleFlag, setTitleFlag] = useState(false)
    const [UploadComplaintDetails, setUploadComplaintDetails] = useState(false)
    const [SiteVisitDetails, setSiteVisitDetails] = useState(false)
    const [TrackPopUpShow, setTrackPopUpShow] = useState(false)

    const handleBoundaries = () => {
        setBoundariesPopUpShow(!BoundariesPopUpShow)
    }

    const handleAction = (Title) => {
        setActionPopUpShow(!ActionPopUpShow)
        setTitleFlag(Title)
    }

    const handleUploadComplaintDetails = () => {
        setUploadComplaintDetails(!UploadComplaintDetails)
    }

    const handleSiteVisitDetails = () => {
        setSiteVisitDetails(!SiteVisitDetails)
    }

    const handleTrack = () => {
        setTrackPopUpShow(!TrackPopUpShow)
    }


    return (
        <>
            <HeaderIllegal />
            <div className="wrapper bg-change">

                <IllegalConstructionSidebar />

                <div className="content1 content mt-1 " style={{}}>

                    <div className="row">
                        <div className="col-12">
                            {/* Site Verification */}
                            <h5 className="text-dark fw-bold ps-3 pt-3 all_heading_fontsize">{t('EncroachmentDashboard.SiteVerification')}
                                {/* <span className="float-end add_btn">Add</span> */}
                                {/* <span className="add_btn  float-end cursor-pointer" onClick={() => {
                                                handleAddDepartment(true)
                                            }}
                                                title="Add">
                                                <i class="fa-solid fa-plus pe-1"></i> Add
                                            </span> */}
                            </h5>
                        </div>
                    </div>
                    <div className="row ps-3 pt-2 eic_table_styles" >

                        <div class="col-12 col-lg-3 pt-2">

                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.FromDate')}</label><br />
                            <input type="date" placeholder="" name="date" className="form-control" id="email" required />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">

                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.ToDate')}</label><br />
                            <input type="date" placeholder="" name="date" className="form-control" id="email" required />
                        </div>


                        <div class="col-12 col-lg-3 pt-2">
                            <ZoneNameCommanDDL
                                ZoneNameID={ZoneNameID}
                                setZoneNameID={setZoneNameID}
                                Flag='Insert'
                                ApiFlag='Master'
                                data=''
                                IsPost=''
                                Language={Language}
                            />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">
                            <WardNameCommanDDL />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">
                            <ConstructionTypeCommanDDL />
                        </div>

                        <div className="col-12 col-lg-3 col-md-3 mt-3">

                            <button type="button" className="btn btn-success mx-3 mt-4">Search</button>
                            <button type="button" className="btn btn-danger mt-4">Clear</button>
                        </div>

                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SiteVisitDate')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Ward')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.AreaName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.UploadComplaintDetails')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.SiteVisitDetails')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ConstructionBoundariesDetails')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Notice')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Action')}</th>
                                            </tr>

                                        </thead>
                                        <tbody>

                                            <tr className="verticalAlign">
                                                <td className="py-1" align="center">1</td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>
                                                <td className="text-center"></td>

                                                <td className="text-center"
                                                    onClick={() => handleUploadComplaintDetails()}
                                                >
                                                    <button className="view_button">
                                                        {t('EncroachmentDashboard.View')}
                                                    </button>
                                                </td>

                                                <td className="text-center"
                                                    onClick={() => handleSiteVisitDetails()}
                                                >
                                                    <button className="view_button">
                                                        {t('EncroachmentDashboard.View')}
                                                    </button>
                                                </td>

                                                <td className="text-center">
                                                    <button className="view_button"
                                                        onClick={() => handleBoundaries()}
                                                    >
                                                        {t('EncroachmentDashboard.View')}

                                                    </button>
                                                </td>



                                                <td className="text-center"
                                                    onClick={() => handleUploadComplaintDetails()}
                                                >
                                                    <span className="cursor-pointer">
                                                        {/* {t('EncroachmentDashboard.View')} */}
                                                        <i class="fa-solid fa-eye"></i> </span>
                                                </td>


                                                <td className="text-center"
                                                >
                                                    <button className="view_button">
                                                        Verified
                                                    </button>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                            </div>


                        </div>

                    </div>

                </div>
            </div>


            {
                BoundariesPopUpShow ?
                    <BoundariesPopup
                        message="Construction Boundaries"
                        handleBoundaries={handleBoundaries}
                    // heading="Forward"
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }

            {
                ActionPopUpShow ?
                    <ActionPopup
                        message="Action"
                        handleAction={handleAction}
                        TitleFlag={TitleFlag}
                    // heading="Forward"
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }

            {
                TrackPopUpShow ?
                    <TrackPopup
                        message="Add"
                        handleTrack={handleTrack}
                        heading="Track"
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }

            {
                SiteVisitDetails ?
                    <SiteVisitDetailsPopup
                        // message="Add"
                        handleSiteVisitDetails={handleSiteVisitDetails}
                        heading={t('EncroachmentDashboard.SiteVisitDetails')}
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }

            {
                UploadComplaintDetails ?
                    <UploadComplaintDetailsPopup
                        // message="Add"
                        handleUploadComplaintDetails={handleUploadComplaintDetails}
                        heading={t('EncroachmentDashboard.UploadComplaintDetails')}
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }



        </>
    )
}

